import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiParameters } from 'src/app/configs/api.params';
import { IWebhook } from '../models/webhook.model';

/**
 * @ignore
 */
@Injectable({
  providedIn: 'root',
})
export class WebhookService {
  public apiEndPoint = apiParameters.url;

  constructor(private http: HttpClient) {}

  addWebhook(companyId: string, webhook: IWebhook): Observable<any> {
    let body = {
      baseUrl: webhook.baseUrl,
      eventId: webhook.eventId,
      authorization: webhook.authorization
    };
    return this.http.post(
      `${apiParameters.url}/companies/${companyId}/webhooks`,
      body
    );
  }

  editWebhook(companyId: string, webhook: IWebhook): Observable<any> {
    let body = {
      baseUrl: webhook.baseUrl,
      authorization: webhook.authorization
    };
    return this.http.patch(
      `${apiParameters.url}/companies/${companyId}/webhooks/${webhook.id}`,
      body
    );
  }

  deleteWebhook(companyId: string, webhook: IWebhook): Observable<any> {
    return this.http.delete(
      `${apiParameters.url}/companies/${companyId}/webhooks/${webhook.id}`
    );
  }

  getEvents(): Observable<any> {
    return this.http.get(`${apiParameters.url}/events`);
  }

  getCompanyWebhooks(companyId: string): Observable<any> {
    return this.http.get(
      `${apiParameters.url}/companies/${companyId}/webhooks`
    );
  }
}
